const translations: Record<string, string> = {
  action_save: 'Save',
  action_saving: 'Saving...',
  // Greeting
  greeting_morning: 'Good morning',
  greeting_day: 'Good afternoon',
  greeting_evening: 'Good evening',

  // Nav sections
  nav_cabinet: 'Cabinet',
  nav_operations: 'Operations',
  nav_system: 'System',
  nav_platform_admin: 'Platform Admin',
  nav_administration: 'Administration',

  // Nav items
  nav_dashboard: 'Dashboard',
  nav_owner_dashboard: 'Owner Dashboard',
  nav_platform_dashboard: 'Dashboard',
  nav_platform_tenants: 'Tenants Overview',
  nav_platform_users: 'Users Overview',
  nav_platform_counterparties: 'Counterparties Overview',
  nav_platform_assets: 'Assets Overview',
  nav_onboarding: 'Onboarding',
  nav_counterparties: 'Counterparties',
  nav_assets: 'Assets',
  nav_contracts: 'Contracts',
  nav_documents: 'Documents',
  nav_forecast: 'Forecast',
  nav_bess: 'BESS',
  nav_comdisp: 'Commercial Dispatcher',
  nav_monitor: 'Monitor',
  nav_settings: 'Settings',
  nav_tenants: 'Tenants',
  nav_tenant_users: 'Tenant Users',
  nav_roles: 'Roles',

  // Topbar
  topbar_search: 'Search...',
  topbar_notifications: 'Notifications',
  topbar_add_station: 'Add station',
  topbar_profile: 'Profile',
  topbar_settings: 'Settings',
  topbar_company: 'Company',
  topbar_team: 'Team',
  topbar_logout: 'Sign out',

  // Home page
  home_breadcrumb_home: 'Home',
  home_breadcrumb_dashboard: 'Dashboard',
  home_export: 'Export',
  home_submit_mms: 'Submit MMS',
  home_hourly_chart: 'Hourly generation schedule',
  home_vs_yesterday: '↑ 12% vs yesterday',
  home_col_hour: 'Hour',
  home_col_forecast: 'Forecast',
  home_col_fact: 'Actual',
  home_col_deviation: 'Deviation',
  home_col_price: 'DAM Price',
  home_col_revenue: 'Revenue',

  // Notifications
  notif_inverter_alarm: 'Inverter #3 — alarm',
  notif_mms_confirmed: 'MMS report confirmed',
  notif_market_digest: 'New market digest',
  notif_2h: '2h ago',
  notif_yesterday: 'yesterday',

  // User menu
  user_guest: 'Guest',

  // Assets page
  assets_title: 'Assets',
  assets_subtitle: 'Manage your energy generation and storage assets',
  assets_search: 'Search by name or EIC code...',
  assets_all_types: 'All Types',
  assets_loading: 'Loading assets...',
  assets_not_found: 'No assets found',
  assets_not_found_hint: 'Assets are created from a counterparty profile',
  assets_filter_hint: 'Try adjusting your filters',
  assets_col_asset: 'Asset',
  assets_col_eic: 'EIC Code',
  assets_col_type: 'Type',
  assets_col_capacity: 'Capacity',
  assets_col_region: 'Region',
  assets_col_status: 'Status',
  assets_col_counterparty: 'Counterparty',

  // Contracts page
  contracts_title: 'Contracts',
  contracts_subtitle: 'Manage PPA, supply, and service contracts',
  contracts_search: 'Search by number or counterparty...',
  contracts_loading: 'Loading contracts...',
  contracts_not_found: 'No contracts found',
  contracts_not_found_hint: 'Contracts are created from an asset profile',
  contracts_filter_hint: 'Try a different search term',
  contracts_col_number: 'Number',
  contracts_col_type: 'Type',
  contracts_col_counterparty: 'Counterparty',
  contracts_col_asset: 'Asset',
  contracts_col_period: 'Period',
  contracts_col_status: 'Status',

  // Documents page
  documents_title: 'Documents',
  documents_subtitle: 'Manage document metadata and track verification status',
  documents_search: 'Search by file name or counterparty...',
  documents_loading: 'Loading documents...',
  documents_not_found: 'No documents found',
  documents_not_found_hint: 'Documents are added from asset or counterparty profiles',
  documents_filter_hint: 'Try a different search term',
  documents_col_file: 'File',
  documents_col_type: 'Type',
  documents_col_counterparty: 'Counterparty',
  documents_col_asset_contract: 'Asset / Contract',
  documents_col_status: 'Status',
  documents_col_uploaded: 'Uploaded',
  documents_col_by: 'By',

  // Forecast page
  forecast_title: 'Forecast',
  forecast_subtitle: 'Generation forecasting · ML model v0.2.2',
  forecast_export: 'Export XLSX',
  forecast_weather_title: 'Weather / Bolhrad',
  forecast_weather_partly_cloudy: 'Partly cloudy',
  forecast_weather_insolation: 'Insolation',
  forecast_weather_clouds: 'Cloud cover',
  forecast_weather_wind: 'Wind',
  forecast_weather_humidity: 'Humidity',
  forecast_model_title: 'ML Model',
  forecast_model_version: 'Version',
  forecast_model_updated: 'Updated',
  forecast_model_horizon: 'Horizon',
  forecast_model_training: 'Training',
  forecast_model_mape: 'MAPE (7 days)',
  forecast_accuracy: 'Forecast accuracy',
  forecast_accuracy_period: 'over the last 30 days',

  // Counterparties page
  cp_title: 'Counterparties',
  cp_subtitle: 'Manage your business counterparties and partners',
  cp_new: 'New Counterparty',
  cp_search: 'Search by name or EDRPOU...',
  cp_loading: 'Loading counterparties...',
  cp_not_found: 'No counterparties found',
  cp_not_found_hint: 'Create your first counterparty to get started',
  cp_filter_hint: 'Try a different search term',
  cp_start_onboarding: 'Start Onboarding',
  cp_col_name: 'Name',
  cp_col_edrpou: 'EDRPOU',
  cp_col_country: 'Country',
  cp_col_status: 'Status',
  cp_col_onboarding: 'Onboarding',
  cp_col_assets: 'Assets',
  cp_col_created: 'Created',

  // Onboarding page
  ob_title: 'Counterparty Onboarding',
  ob_subtitle: 'Complete the 5-step form to register your organization in the Helios system.',
  ob_step_company: 'Company',
  ob_step_legal: 'Legal',
  ob_step_contact: 'Contact',
  ob_step_bank: 'Bank',
  ob_step_roles: 'Roles',
  ob_back: 'Back',
  ob_next: 'Next',
  ob_submit: 'Submit',
  ob_submitting: 'Submitting...',
  ob_success_title: 'Onboarding Submitted',
  ob_success_text: 'Your counterparty has been created and is pending review. ID:',
  ob_complete: 'Complete Onboarding',
  ob_completing: 'Completing...',
  ob_go_to_profile: 'Go to Counterparty Profile',
  ob_fill_required: 'Please fill in all required fields',
  ob_select_role: 'Please select at least one role',

  // Onboarding Step 1 — Company Identity
  ob_s1_title: 'Company Identity',
  ob_s1_subtitle: 'Enter the basic identification details of your company.',
  ob_s1_name: 'Company Name',
  ob_s1_name_ph: 'e.g. Helios Energy LLC',
  ob_s1_shortName: 'Short Name',
  ob_s1_shortName_ph: 'e.g. Helios',
  ob_s1_edrpou: 'EDRPOU Code',
  ob_s1_edrpou_ph: '8-digit code',
  ob_s1_taxId: 'Tax ID',
  ob_s1_taxId_ph: 'Tax identification number',
  ob_s1_country: 'Country',
  ob_s1_country_ph: 'e.g. Ukraine',

  // Onboarding Step 2 — Legal Profile
  ob_s2_title: 'Legal Profile',
  ob_s2_subtitle: 'Provide the legal and registration details of your entity.',
  ob_s2_fullLegalName: 'Full Legal Name',
  ob_s2_fullLegalName_ph: 'Full legal entity name as in registry',
  ob_s2_legalAddress: 'Legal Address',
  ob_s2_legalAddress_ph: 'Registered legal address',
  ob_s2_actualAddress: 'Actual Address',
  ob_s2_actualAddress_ph: 'Physical office address',
  ob_s2_registrationCountry: 'Registration Country',
  ob_s2_registrationCountry_ph: 'e.g. Ukraine',
  ob_s2_vatStatus: 'VAT Status',
  ob_s2_vatStatus_ph: 'Select VAT status',
  ob_s2_vat_registered: 'Registered',
  ob_s2_vat_not_registered: 'Not Registered',
  ob_s2_vat_exempt: 'Exempt',
  ob_s2_vatNumber: 'VAT Number',
  ob_s2_vatNumber_ph: 'VAT identification number',
  ob_s2_directorName: 'Director Name',
  ob_s2_directorName_ph: 'Full name of CEO / Director',
  ob_s2_authorizedPerson: 'Authorized Person',
  ob_s2_authorizedPerson_ph: 'Name of person authorized to sign',
  ob_s2_basisOfAuthority: 'Basis of Authority',
  ob_s2_basisOfAuthority_ph: 'Statute / Power of attorney / Order',

  // Onboarding Step 3 — Primary Contact
  ob_s3_title: 'Primary Contact',
  ob_s3_subtitle: 'Designate the main point of contact for your organization.',
  ob_s3_fullName: 'Full Name',
  ob_s3_fullName_ph: 'e.g. Ivan Petrenko',
  ob_s3_position: 'Position',
  ob_s3_position_ph: 'e.g. Chief Operations Officer',
  ob_s3_email: 'Email',
  ob_s3_email_ph: 'contact@company.com',
  ob_s3_phone: 'Phone',
  ob_s3_phone_ph: '+380 50 123 4567',
  ob_s3_contactType: 'Contact Type',
  ob_s3_contactType_ph: 'Select contact type',
  ob_s3_ct_technical: 'Technical',
  ob_s3_ct_legal: 'Legal',
  ob_s3_ct_financial: 'Financial',
  ob_s3_ct_dispatch: 'Dispatch',
  ob_s3_ct_commercial: 'Commercial',
  ob_s3_ct_general: 'General',
  ob_s3_isPrimary: 'Set as primary contact',

  // Onboarding Step 4 — Bank Account
  ob_s4_title: 'Bank Account',
  ob_s4_subtitle: 'Provide your primary banking details for settlements.',
  ob_s4_bankName: 'Bank Name',
  ob_s4_bankName_ph: 'e.g. PrivatBank',
  ob_s4_iban: 'IBAN',
  ob_s4_iban_ph: 'UA123456789012345678901234567',
  ob_s4_currency: 'Currency',
  ob_s4_currency_ph: 'UAH / EUR / USD',
  ob_s4_mfo: 'MFO / SWIFT',
  ob_s4_mfo_ph: 'Bank MFO or SWIFT code',
  ob_s4_accountHolder: 'Account Holder',
  ob_s4_accountHolder_ph: 'Legal name of account holder',
  ob_s4_isPrimary: 'Set as primary bank account',

  // Onboarding Step 5 — Roles
  ob_s5_title: 'Business Roles',
  ob_s5_subtitle: 'Select all roles that apply to your organization. You can choose multiple.',
  ob_s5_selected: 'Selected roles',
  ob_s5_none: 'No roles selected',
  ob_s5_role_generator_owner: 'Generator Owner',
  ob_s5_role_generator_owner_desc: 'Own and operate renewable energy generation assets',
  ob_s5_role_supplier: 'Supplier',
  ob_s5_role_supplier_desc: 'Supply electricity to end consumers',
  ob_s5_role_trader: 'Trader',
  ob_s5_role_trader_desc: 'Buy and sell electricity on wholesale markets',
  ob_s5_role_consumer: 'Consumer',
  ob_s5_role_consumer_desc: 'Purchase electricity for own consumption',
  ob_s5_role_balancing_group_member: 'Balancing Group Member',
  ob_s5_role_balancing_group_member_desc: 'Participate in balancing group arrangements',
  ob_s5_role_bess_operator: 'BESS Operator',
  ob_s5_role_bess_operator_desc: 'Operate battery energy storage systems',
  ob_s5_role_service_provider: 'Service Provider',
  ob_s5_role_service_provider_desc: 'Provide technical or commercial services',

  // Login page
  login_welcome: 'Welcome back',
  login_subtitle: 'Sign in to your workspace',
  login_label_login: 'Login',
  login_label_password: 'Password',
  login_btn: 'Sign in →',
  login_checking: 'Checking...',
  login_error_empty: 'Enter your login and password',
  login_error_wrong: 'Invalid login or password',
  login_error_rate: 'Too many sign-in attempts. Try again in {{sec}} s',
  login_error_unavailable: 'Server is temporarily unavailable — please retry',
  login_forgot: 'Forgot password?',
  login_restore: 'Restore',
  login_new_company: 'New company?',
  login_demo: 'Request demo',

  // BESS page
  bess_title: 'Battery Storage',
  bess_subtitle: 'Battery energy storage system telemetry',
  bess_export: 'Export',
  bess_soc: 'State of Charge',
  bess_soh: 'State of Health',
  bess_status: 'Status',
  bess_live: 'Live',
  bess_stale: 'Stale',
  bess_discharge: 'Discharge / Output Active',
  bess_charge: 'Charge available',
  bess_power: 'Active power',
  bess_power_flow: 'Power flow',
  bess_voltage: 'Battery voltage',
  bess_current: 'Battery current',
  bess_bms: 'BMS status',
  bess_pcs: 'PCS running status',
  bess_config: 'Configuration',
  bess_nominal_capacity: 'Nominal capacity',
  bess_nominal_power: 'Nominal power',
  bess_visible_capacity: 'Visible usable capacity',
  bess_pcs_avail: 'PCS availability',
  bess_updated: 'Updated',
  bess_refresh: 'Refresh',
  bess_no_telemetry: 'No BESS telemetry available',
  bess_retry: 'Retry',
  bess_section_gauges: 'Battery Gauges',
  bess_section_battery: 'Battery State',
  bess_section_power: 'Power & Config',
  bess_section_status: 'System Status',

  // UEEX market data
  nav_market: 'Market',
  nav_market_ueex: 'UEEX',
  nav_info_analytics: 'Info Analytics',
  nav_owner_home: 'Dashboard',
  nav_disp_home: 'Dashboard',
  nav_sec_dispatch: 'Dispatch',
  nav_disp_fact: 'Actuals',
  nav_disp_scada: 'SCADA',
  nav_sec_finance: 'Finance',
  nav_fin_cashflow: 'Cash Flow',
  nav_fin_pl: 'P&L',
  nav_fin_reports: 'Reports',
  nav_gen: 'Generation',
  nav_dispatch2: 'Dispatch',
  nav_incidents: 'Incidents',
  nav_reports: 'Reporting',
  nav_sec_market: 'Market',
  nav_market_prices: 'Prices',
  nav_gen_deviation: 'Deviation',
  nav_bess_state: 'Current state',
  nav_fin_income: 'Income',
  nav_fin_charges: 'Charges',
  nav_fin_bess_arb: 'BESS arbitrage',
  nav_an_news: 'News',
  nav_notifications: 'Notifications',
  nav_trade_schedule: 'Trade schedule',
  nav_mms: 'MMS submission',
  nav_disp_commands: 'Dispatcher commands',
  nav_scada_monitoring: 'Equipment monitoring',
  nav_scada_telemetry: 'Telemetry',
  nav_scada_control: 'Manual control',
  nav_scada_events: 'Events',
  nav_bess_charge: 'Charge',
  nav_bess_discharge: 'Discharge',
  nav_bess_arbitrage: 'Arbitrage',
  nav_assets_list: 'Plant list',
  nav_inc_faults: 'Faults',
  nav_inc_limits: 'Curtailments',
  nav_inc_alarms: 'Alarms',
  nav_rep_regulatory: 'Regulatory',
  nav_rep_management: 'Management',
  nav_rep_dispatch: 'Dispatch',
  nav_doc_contracts: 'Contracts',
  nav_doc_acts: 'Acts',
  nav_doc_correspondence: 'Correspondence',
  nav_set_users: 'Users',
  nav_set_roles: 'Roles',
  nav_set_integrations: 'Integrations',
  nav_sec_analytics: 'Analytics',
  nav_an_market: 'Market',
  ueex_page_title: 'Ukrainian Energy Exchange',
  ueex_page_subtitle: 'Auction electricity prices + Guarantees of Origin (Solar GO)',
  ueex_page_window: 'Window',
  ueex_page_days: 'days',
  ueex_tab_electricity: 'Electricity',
  ueex_tab_solar_go: 'Solar GO',
  ueex_tab_auctions: 'Auctions',
  ueex_kpi_base_wavg: 'BASE weighted-avg price',
  ueex_kpi_block_wavg: 'Block weighted-avg price',
  ueex_kpi_premium: 'BASE premium',
  ueex_chart_price_title: 'Daily price trend (volume-weighted across deals)',
  ueex_chart_volume_title: 'Daily realized volumes',
  ueex_top_sellers_base: 'Top BASE sellers (by volume in window)',
  ueex_no_data: 'No data',
  ueex_seller: 'Seller',
  ueex_deals: 'Deals',
  ueex_wavg_price: 'Avg price',
  ueex_revenue: 'Revenue',
  ueex_solar_banner_title: 'Solar GO — supply-only market',
  ueex_solar_banner_text: 'Over 90 days, 0 MWh of solar certificates were sold on UEEX. Ask prices serve as a reference baseline for direct B2B contracts; no automated deals here.',
  ueex_solar_avg_ask: 'Avg ask price',
  ueex_solar_sell_positions: 'Sell positions',
  ueex_solar_closed_deals: 'Closed deals',
  ueex_solar_offered_volume: 'Offered volume',
  ueex_solar_chart_title: 'Solar GO ask prices + offered volume',
  ueex_recent_auctions: 'Recent auctions',
  ueex_auc_num: 'Number',
  ueex_auc_date: 'Date',
  ueex_auc_type: 'Type',
  ueex_auc_state: 'State',
  ueex_auc_positions: 'Positions',
  ueex_auc_closed: 'Closed',
  ueex_widget_title: 'UEEX — current prices',
  ueex_widget_view_all: 'View all',
  ueex_widget_loading: 'Loading...',
  ueex_widget_base_label: 'BASE (24/7)',
  ueex_widget_block_label: 'Block position',
  ueex_widget_solar_label: 'Solar GO (ask)',
  ueex_widget_source: 'Source: epbets.ueex.com.ua',
  ueex_widget_subtitle: 'Recent price trend',
  ueex_widget_no_recent_data: 'No closed deals in the last week',
  ueex_sections_title: 'Sections',
  ueex_section_electric_power: 'Electricity',
  ueex_section_bilateral_contracts: 'Bilateral contracts',
  ueex_section_solar_go: 'Solar GO',
  ueex_section_renewable_go: 'Renewable GO compare',
  ueex_section_auctions: 'All auctions',
  ueex_external_link: 'Official UEEX site',
  ueex_kpi_peak_wavg: 'PEAK weighted-avg price',
  ueex_chart_auctions_title: 'Results of electricity auctions',
  ueex_chart_auctions_subtitle: 'Volume-weighted avg of closed deals per day, UAH/MWh without VAT',
  ueex_source_note: 'Source',
  ueex_bilateral_title: 'Bilateral market trading results',
  ueex_bilateral_subtitle: 'Electricity positions',
  ueex_records: 'records',
  ueex_renewable_title: 'Renewable Guarantees of Origin',
  ueex_renewable_subtitle: 'Solar/Wind/Hydro/Bio comparison',
  ueex_renewable_placeholder: 'Comparison chart will be added in the next iteration',
  ueex_renewable_data_source: '(data already collected in DB; dashboard query queued)',
  ueex_all_auctions_title: 'All auctions in window',
  ueex_all_types: 'All types',
  ueex_loading: 'Loading data...',
  ueex_widget_days_suffix: 'd',
  ueex_widget_deals: 'deals',
  ueex_widget_positions: 'positions',
  ueex_widget_no_peak: 'No PEAK trading in window',
  nav_sko: 'SKO',
  sko_page_title: 'Renewables Curtailment Management System',
  sko_page_subtitle: 'PRS schedules and curtailment events from Ukrenergo',
  sko_sections_title: 'Sections',
  sko_section_prs: 'PRS schedules',
  sko_section_curtailment: 'Curtailment events',
  sko_section_about: 'About SKO',
  sko_external_link: 'Official Ukrenergo RES site',
  sko_prs_banner_title: 'Phase A — Dry-run',
  sko_prs_banner_text: 'XML schedules are generated from v0.2.2 forecast and stored in DB. SOAP submission to lms.ua.energy will be enabled after the TSO contract and VPN tunnel are in place.',
  sko_prs_table_title: 'Generated PRS',
  sko_prs_col_date: 'Delivery date',
  sko_prs_col_asset: 'Plant',
  sko_prs_col_rev: 'Rev',
  sko_prs_col_points: 'Points',
  sko_prs_col_energy: 'Energy',
  sko_prs_col_status: 'Status',
  sko_prs_preview: 'Preview',
  sko_prs_preview_title: 'PRS XML preview',
  sko_close: 'Close',
  sko_loading: 'Loading...',
  sko_no_data: 'No data',
  sko_curt_banner_title: 'Curtailment event log',
  sko_curt_banner_text: 'Log dispatcher curtailment / disconnection events here. This data will later feed forecast model features and compliance reports.',
  sko_curt_events_title: 'Curtailment events',
  sko_curt_add_event: 'Add event',
  sko_curt_col_asset: 'Plant',
  sko_curt_col_start: 'Start',
  sko_curt_col_end: 'End',
  sko_curt_col_pct: 'Limit',
  sko_curt_col_reason: 'Reason',
  sko_curt_col_source: 'Source',
  sko_curt_col_dispatcher: 'Dispatcher',
  sko_curt_active: 'Ongoing',
  sko_save: 'Save',
  sko_saving: 'Saving...',
  sko_about_title: 'About the Curtailment Management System',
  sko_about_p1: 'SKO is Ukrenergo system for bidirectional information exchange with RES producers regarding availability and curtailment needs.',
  sko_about_p2: 'Producers must submit PRS (Planned Resource Schedule) — daily 15-min generation schedules — via SOAP API (IEC 62325-451-7) at lms.ua.energy. TSO dispatcher can issue load-reduction commands.',
  sko_about_p3: 'Phase A (current) — dry-run infrastructure prep: XML generator and curtailment event log before official integration.',
  sko_about_phase_status: 'Phase status:',
  sko_inbox_title: 'Inbox from TSO',
  sko_inbox_subtitle: 'SKO commands (top-10)',
  sko_inbox_view_all: 'All',
  sko_inbox_loading: 'Loading...',
  sko_inbox_empty: 'No new commands',
  sko_inbox_no_asset: '(stakeholder-wide)',
  sko_inbox_curtailment_to: 'Limit to',
  sko_inbox_ack_in: 'ACK in',
  sko_inbox_min: 'min',
  sko_inbox_ack: 'Acknowledge',
  sko_inbox_details: 'Details',
  sko_bell_pending: 'Pending acknowledgement',
  sko_bell_active: 'Active',
  sko_bell_critical: 'Critical',
  sko_bell_none: 'No commands',
  sko_section_inbox: 'Commands inbox',
  sko_inbox_full_title: 'All SKO commands',
  sko_inbox_filter_all: 'All statuses',
  nav_trading: 'Trading',
  nav_trading_overview: 'Overview',
  nav_trading_dam: 'DAM',
  nav_trading_idm: 'IDM',
  trading_overview_title: 'Combined market analytics',
  trading_overview_subtitle: 'Spot OREE (DAM + IDM) vs OTC UEEX vs our actual generation',
  trading_dam_title: 'Day-ahead market',
  trading_dam_subtitle: 'OREE day-ahead — Unified Energy System of Ukraine (OES)',
  trading_idm_title: 'Intraday market',
  trading_idm_subtitle: 'OREE intraday — Unified Energy System of Ukraine (OES)',
  oree_widget_title: 'OREE Electricity Market',
  oree_widget_subtitle: 'DAM + IDM spot prices, source: www.oree.com.ua',
  oree_widget_dam_today: 'DAM price today',
  oree_widget_idm_today: 'IDM price today',
  oree_widget_dam_7d: 'DAM 7-day average',
  oree_widget_idm_7d: 'IDM 7-day average',
  oree_widget_average_label: 'weighted price',
  oree_widget_days_suffix: 'd',
  oree_dam_label: 'Day-ahead market',
  oree_idm_label: 'Intraday market',
  oree_volume_label: 'Trading volume',
  oree_potential_revenue_7d: 'Potential revenue for 7 days',
  oree_potential_revenue_note: 'How much we could earn selling actual generation on DAM instead of the green tariff',
  oree_tr_zone_label: 'Trade zone',
  oree_daily_price_title: 'Daily weighted price dynamics',
  oree_hourly_profile_title: 'Hourly prices and volumes for the day',
  oree_vs_ueex_title: 'Comparison: spot (OREE) vs OTC (UEEX BASE)',
  oree_vs_generation_title: 'Potential revenue: our generation × DAM price (last 7 days)',
  oree_vs_generation_note: 'Sum across all our SES using actual inverter data (modbus). Revenue = actual MWh × DAM hourly price.',
  common_loading: 'Loading…',
  oree_kpi_price_unit_note: 'UAH/MWh · daily weighted average',
  oree_kpi_zone_value: 'UA OES',
  oree_kpi_zone_note: 'Unified Energy System — main grid',
  oree_hourly_empty: 'OREE has not published data for this date yet. Pick an earlier date.',
  oree_hourly_widget_title: 'DAM — hourly prices and volumes for the day',
  oree_hourly_widget_subtitle: 'OREE day-ahead spot data, hourly',
  oree_hourly_kpi_wavg: 'Daily weighted-average price',
  oree_hourly_kpi_peak: 'Peak price',
  oree_hourly_kpi_low: 'Low price',
  oree_hourly_kpi_total_vol: 'Total trading volume',
  curtailment_banner_title: 'Active generation curtailment',
  curtailment_banner_cap_label: 'Limited to',
  curtailment_banner_pct_suffix: 'of nameplate',
  curtailment_banner_since: 'since',
  curtailment_banner_source: 'Source',
  curtailment_banner_source_auto: 'auto-detected by curtailment detector',
  curtailment_banner_source_sko: 'SKO dispatch command',
  curtailment_banner_source_analyst: 'analyst reconstruction',
  curtailment_banner_view_sko: 'SKO details',
  nav_osr: 'OSR',
  osr_page_title: 'OSR Commands (Distribution System Operator)',
  osr_page_subtitle: 'Curtailment commands from the local DSO (Облэнерго) — NOT compensated. Unlike SKO from Укренерго.',
  osr_log_new: 'Log command',
  osr_cancel: 'Cancel',
  osr_save: 'Save',
  osr_saving: 'Saving…',
  osr_close_event: 'Close',
  osr_status_active: 'Active',
  osr_info_title: 'Why this is separate from SKO:',
  osr_info_body: 'OSR is a command from the local operator (Облэнерго), usually delivered by phone or email. Unlike SKO from Укренерго, this is NOT compensated. The DAM forecast is automatically clamped to the OSR cap.',
  osr_log_form_title: 'New OSR command',
  osr_field_asset: 'Asset',
  osr_field_started: 'Started at',
  osr_field_pct: '% of nameplate',
  osr_field_pmax_kw: 'Cap in kW',
  osr_field_dispatcher: 'Dispatcher (who relayed)',
  osr_field_org: 'Organization',
  osr_field_reason: 'Reason',
  osr_field_notes: 'Notes',
  osr_select_asset: 'select SES',
  osr_section_active: 'Active commands',
  osr_section_past: 'History',
  osr_empty_active: 'No active OSR commands.',
  osr_empty_past: 'No history yet.',
  osr_col_asset: 'SES',
  osr_col_started: 'Started',
  osr_col_ended: 'Ended',
  osr_col_limit: 'Limit',
  osr_col_dispatcher: 'Dispatcher',
  osr_col_reason: 'Reason',
  curtailment_banner_title_osr: 'Active OSR curtailment (not compensated)',
  curtailment_banner_title_sko: 'Active SKO command (compensated by Укренерго)',
  curtailment_banner_source_dispatcher_phone: 'dispatcher phone call',
  curtailment_banner_source_dispatcher_email: 'dispatcher email',
  curtailment_banner_view_osr: 'OSR details',
  greeting_night: 'Good night',
  d_demo_data: 'demo data (API unavailable)',
  d_disp_console: 'Dispatcher console',
  d_ses_plural: 'solar plants',
  d_u_uah: 'UAH',
  d_u_mwh: 'MWh',
  d_u_mw: 'MW',
  d_u_gwh: 'GWh',
  d_u_wm2: 'W/m²',
  d_kpi_month_rev: 'Revenue this month',
  d_kpi_guaranteed: 'guaranteed (forecast × DAM)',
  d_kpi_contract_rdn: 'DAM contract −3%',
  d_kpi_today_rev: 'Revenue today',
  d_kpi_sold_da: 'sold day-ahead on forecast',
  d_kpi_tech_status: 'Technical status',
  d_kpi_generating: 'generating',
  d_kpi_current_status: 'current plant status',
  d_kpi_updates_auto: 'updates automatically',
  d_kpi_forecast_today: 'Forecast today',
  d_kpi_expected_gen: 'expected daily output',
  d_kpi_fact_now: 'actual now',
  d_dkpi_cur_gen: 'Current generation',
  d_dkpi_total_power_now: 'total power now',
  d_dkpi_modbus_src: 'from Modbus / SCADA',
  d_dkpi_model_weather: 'model v0.2.2 · weather forecast',
  d_dkpi_fulfilment: 'Forecast fulfilment',
  d_dkpi_fact_fc_avg: 'actual / forecast now (avg)',
  d_dkpi_portfolio_eff: 'portfolio efficiency',
  d_map_title: 'Plant map',
  d_map_weather: 'Weather',
  d_map_no_telemetry: 'no telemetry',
  d_map_today_fact: 'Today (actual)',
  d_map_forecast: 'Forecast',
  d_map_revenue_guar: 'Revenue (guar.)',
  d_map_insolation: 'Insolation',
  d_map_cloud: 'cloud cover',
  d_btn_details: 'Details',
  d_rev_title: 'Revenue: plan vs actual',
  d_rev_subtitle: 'estimated (forecast × DAM) vs actual · revenue',
  d_p_today: 'Today',
  d_p_10d: '10 days',
  d_p_month: 'Month',
  d_p_quarter: 'Quarter',
  d_p_year: 'Year',
  d_rev_estimated: 'Estimated',
  d_rev_actual: 'Actual',
  d_rev_losses: 'Losses',
  d_rev_plan_fulfil: 'Plan fulfilment',
  d_chart_loading: 'Loading…',
  d_chart_no_data: 'No data for the period',
  d_plan: 'Plan',
  d_fact: 'Actual',
  d_plan_forecast: 'Plan (forecast)',
  d_gen_title: 'Generation: plan vs actual',
  d_gen_subtitle: 'forecast vs actual output · MWh',
  d_gen_shortfall: 'Shortfall',
  d_gen_fulfil: 'Fulfilment',
  d_port_title: 'Portfolio plants',
  d_port_fc_eff: 'forecast eff.',
  d_port_rev_day: 'revenue/day',
  d_port_gen_today: 'generated today',
  d_port_not_launched: 'Not launched',
  d_port_fc_now: 'forecast fulfilment now',
  d_port_guar_rev_today: 'Guar. revenue today',
  d_port_installed: 'installed',
  d_port_open: 'Open page',
  d_ops_incidents: 'Incidents',
  d_ops_active: 'active',
  d_ops_no_incidents: 'No active incidents',
  d_ops_lost_value: 'Lost revenue',
  d_ops_lost_sub: 'forgone revenue · estimate today',
  d_ops_by_cause: 'By cause',
  d_ops_no_losses: 'No losses',
  d_ops_uah_day: 'UAH / day',
  d_cause_outage: 'Outage',
  d_cause_curtail: 'DSO curtailment',
  d_ops_resolved: 'resolved',
  d_ops_since: 'since',
  d_ops_days: 'd',
  d_inv_title: 'Inverter status',
  d_inv_sub: 'estimate by actual vs expected power · updates in daytime',
  d_inv_working_portfolio: 'Working (portfolio)',
  d_inv_no_data: 'No data',
  d_inv_st_pending: 'Awaiting launch',
  d_inv_all: 'All',
  d_inv_inv_working: 'inverters working',
  d_inv_works: 'working',
  d_inv_questionable: 'uncertain',
  d_inv_offline: 'offline',
  d_inv_night: 'Estimate unavailable at night',
  d_inv_no_tele: 'No inverter telemetry',
  d_inv_abbr: 'inv.',
  d_inv_at: 'at',
  d_inv_footer: 'ℹ️ Per-inverter telemetry is unavailable on SMA stations (Nikopol, Nikelios) — status is estimated from aggregate power. At night and without sun the estimate is unavailable (this is normal, not a fault).',
  d_sec_imbalance: 'Imbalance this month',
  d_sec_imbalance_sub: 'approx. · imbalance price per acts on the 14–15th',
  d_sec_bess: 'BESS arbitrage',
  d_sec_bess_sub: 'charge in cheap hours / discharge in expensive · data in progress',
  d_sec_settlements_with: 'Settlements with',
  d_sec_offtaker: 'offtaker',
  d_sec_receivables: 'Receivables',
  d_sec_payment_due: 'payment due',
  d_sec_reports: 'Reports',
  d_bc_home: 'Home',
  d_bc_dispatch: 'Dispatch',
  d_bc_forecast: 'Forecast',
  d_bc_analytics: 'Analytics',
  d_bc_market: 'Market',
  d_bc_info: 'News',
  d_bc_assets: 'Assets',
};

export default translations;
